import { environmentHttpClient } from "client/Api/httpClient";

export type WebDavServerModel = {
	id: number;
	name: string;
	url: string;
};

export type FileSystemItemModel = {
	id: string;
	name: string;
	creationDate: string | null;
	modifiedDate: string | null;
	parentId: string;
	bookmarkId: number | null;
} & (
		{
			isFolder: true;
			size: null;
		}
		|
		{
			isFolder: false;
			size: number;
		}
	);

function listServers(signal?: AbortSignal): Promise<WebDavServerModel[]> {
	return environmentHttpClient.get<WebDavServerModel[]>(
		"Documents/WebDav/Servers",
		undefined,
		{
			signal
		}
	);
}

function getServer(id: number, signal?: AbortSignal): Promise<WebDavServerModel> {
	return environmentHttpClient.get<WebDavServerModel>(
		`Documents/WebDav/Servers/${id}`,
		undefined,
		{ signal }
	);
}

function getContent(
	serverId: number,
	folderId: string,
	signal?: AbortSignal
): Promise<FileSystemItemModel[]> {
	return environmentHttpClient.get<FileSystemItemModel[]>(
		`Documents/WebDav/${serverId}/GetContent`,
		{ folderId },
		{
			signal
		}
	);
}

function getFolderNavigationStack(
	serverId: number,
	folderId: string,
	signal?: AbortSignal
): Promise<FileSystemItemModel[]> {
	return environmentHttpClient.get<FileSystemItemModel[]>(
		`Documents/WebDav/${serverId}/GetFolderNavigationStack`,
		{ folderId },
		{ signal }
	);
}

interface WebDavModels {
	server: WebDavServerModel;
	item: FileSystemItemModel;
}

function getWebDavModel(
	serverId: number,
	fileId: string,
	signal?: AbortSignal
): Promise<WebDavModels> {
	return environmentHttpClient.get<WebDavModels>(
		`Documents/WebDav/${serverId}/GetModels`,
		{ fileId },
		{ signal }
	);
}

export {
	listServers,
	getServer,
	getContent,
	getFolderNavigationStack,
	type WebDavModels,
	getWebDavModel
};
